export default __webpack_public_path__ + "static/media/alpharadar-dash-large.800b93a3.jpg";